import { isAfter } from 'date-fns';

export const isFutureDate = (d?: string) => (d ? isAfter(new Date(d), new Date()) : false);
